@if (canSelectAll()) {
  <div class="flex p-2xs">
    <sb-checkbox class="grow" [checked]="allItemsAreSelected()" [disabled]="disabled()" (change)="onSelectAllToggle()">
      {{ 'Select all' | translate }}
    </sb-checkbox>
  </div>
}

<sb-tree [items]="extendedItems()" [nodeTemplateInput]="itemTemplate" [leafTemplateInput]="itemTemplate">
  <ng-template #itemTemplate let-_item="item" let-level="level">
    @let item = typecastTreeItem(_item);
    <div class="flex p-2xs" sbTreeNode [nodePadding]="true" [level]="level">
      <sb-checkbox
        class="grow"
        [checked]="item.checked"
        [indeterminate]="item.indeterminate"
        [disabled]="disabled() || (item.disabled ?? false)"
        (change)="onCheckboxChange($event.checked, item)"
      >
        <span class="truncate">{{ item.text }}</span>
      </sb-checkbox>
    </div>
  </ng-template>
</sb-tree>
